export default __webpack_public_path__ + "static/teko-medium-122ba156d0d4ded0aa243fccf262d3ed.otf";